import { useNode } from '@craftjs/core';
import { Text } from '@descope/page-editor-components';
import React, { useCallback } from 'react';
import { EditorTextSettings } from './EditorTextSettings';

const EditorText = (props: React.ComponentProps<typeof Text>) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLElement) => connect(drag(ref)),
		[connect, drag]
	);

	return <Text ref={refCb} {...props} />;
};

EditorText.craft = {
	name: 'Text',
	props: {
		children: 'Text',
		italic: false,
		typography: 'body1',
		align: 'center',
		fullWidth: false,
		variant: 'primary'
	},
	related: {
		settings: EditorTextSettings
	}
};

export { EditorText };
